var map = {
	"./logo-1-color.png": 1585,
	"./logo-2-color.png": 8538,
	"./logo-3-color.png": 615,
	"./logo-4-color.png": 8336,
	"./logo-5-color.png": 4773,
	"./logo-6-color.png": 4638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4603;